import Layout from "@/layouts/index.vue";

const routes = [
  {
    path: "/seo",
    meta: { title: "SEO" },
    redirect: "/seo/dashboard",
    component: Layout,
    children: [
      {
        path: "/seo/dashboard",
        meta: {
          title: "数据看板",
          icon: "icon-icon-test",
          parentPath: "/seo",
          permissionKey: "seo.dashboard",
          permissionAction: "view",
        },
        component: () => import("@/views/seo/dashboard/index.vue"),
      },
      {
        path: "/seo/effect-report",
        meta: {
          title: "效果月报",
          icon: "el-icon-data-analysis",
          parentPath: "/seo",
          permissionKey: "seo.effect_report",
          permissionAction: "view",
        },
        component: () => import("@/views/seo/effect-report/index.vue"),
      },
      {
        path: "/seo/effect-report/edit",
        meta: {
          title: "月报编辑",
          icon: "el-icon-edit-outline",
          parentPath: "/seo",
          permissionKey: "seo.effect_report",
          permissionAction: "edit",
        },
        component: () => import("@/views/seo/effect-report/edit.vue"),
      },
      {
        path: "/seo/seed",
        meta: {
          title: "主词管理",
          icon: "icon-icon-test",
          parentPath: "/seo",
          permissionKey: "seo.seed",
          permissionAction: "view",
          hidden: true,
        },
        component: () => import("@/views/seo/seed/index.vue"),
      },
      {
        path: "/seo/keyword",
        meta: {
          title: "关键词管理",
          icon: "icon-icon-test",
          parentPath: "/seo",
          permissionKey: "seo.keyword",
          permissionAction: "view",
        },
        component: () => import("@/views/seo/keyword/index.vue"),
      },
      {
        path: "/seo/keyword/site/:siteId",
        meta: {
          title: "站点关键词",
          icon: "icon-icon-test",
          parentPath: "/seo",
          prevPath: "/seo/keyword",
          hidden: true,
          permissionKey: "seo.keyword",
          permissionAction: "view",
        },
        component: () => import("@/views/seo/keyword/index.vue"),
      },
      {
        path: "/seo/sites",
        meta: {
          title: "站点管理",
          icon: "icon-icon-test",
          parentPath: "/seo",
          permissionKey: "seo.keyword",
          permissionAction: "view",
        },
        component: () => import("@/views/seo/site/index.vue"),
      },
      {
        path: "/seo/sites/detail/:siteId",
        meta: {
          title: "站点详情",
          icon: "icon-icon-test",
          parentPath: "/seo",
          prevPath: "/seo/sites",
          hidden: true,
          permissionKey: "seo.keyword",
          permissionAction: "view",
        },
        component: () => import("@/views/seo/site/detail.vue"),
      },
      {
        path: "/seo/cost",
        meta: {
          title: "消耗统计",
          icon: "icon-icon-test",
          parentPath: "/seo",
          permissionKey: "seo.cost",
          permissionAction: "view",
        },
        component: () => import("@/views/seo/cost/index.vue"),
      },
      {
        path: "/seo/api-log",
        meta: {
          title: "API调用日志",
          icon: "icon-icon-test",
          parentPath: "/seo",
          permissionKey: "seo.api_log",
          permissionAction: "view",
        },
        component: () => import("@/views/seo/api-log/index.vue"),
      },
      {
        path: "/seo/auto-run",
        meta: {
          title: "自动执行",
          icon: "icon-icon-test",
          parentPath: "/seo",
          permissionKey: "seo.auto_run",
          permissionAction: "view",
        },
        component: () => import("@/views/seo/auto-run/index.vue"),
      },
      {
        path: "/seo/setting",
        meta: {
          title: "系统设置",
          icon: "icon-icon-test",
          parentPath: "/seo",
          permissionKey: "seo.setting",
          permissionAction: "view",
        },
        component: () => import("@/views/seo/setting/index.vue"),
      },
    ],
  },
];

export default routes;
